import React from "react";
import CheckStep from "../../svg/check-step";

interface StepIndicatorProps {
    step: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ step }) => {
    return (
        <div className="flex justify-center space-x-[24px] mb-6 max-[576px]:mb-[16px]">
            {[1, 2].map((num) => (
                <div key={num} className="flex items-center justify-between">
                    <div
                        className={`w-[48px] h-[48px] max-[576px]:w-[40px] max-[576px]:h-[40px]  flex items-center justify-center rounded-full border-[3px] relative text-2xl font-bold leading-[125%] max-[576px]:text-[18px]
                            ${num < step ? "border-[#24C450] text-black" : "border-gray-400 text-gray-400"}
                        `}
                    >
                        {num < step ? 
                            <div className="absolute bottom-[-2px] right-[-4px]">
                                <CheckStep />
                            </div>
                        : '' }
                        {num}
                    </div>
                    {num != 2 ? 
                        <span 
                            className="w-[64px] h-0.5 ml-[24px] flex max-[576px]:w-[52px] max-[576px]:ml-[16px]"
                            style={{
                                backgroundColor: "#fff", 
                                backgroundImage: "url('/bg/divider.png')", 
                                backgroundPosition: "center center",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "cover"
                            }}
                        ></span>
                    : ''}
                </div>
            ))}            
        </div>
    );
};

export default StepIndicator;